export default __webpack_public_path__ + "images/waiting-room.8ae036d19fcc87e1c8b8f7ba34fe6af2.svg";